import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { designSystem } from "@/styles/theme";

interface StyledBoxProps {
  fontsize?: string;
  overflow?: string;
  margin?: string;
  top?: string;
  maxheight?: string;
  maxwidth?: string;
  fontweight?: string;
  gap?: string;
  aligncontent?: string;
  placeself?: string;
  boxshadow?: string;
  bottom?: string;
  position?: string;
  placecontent?: string;
  width?: string;
  children?: ReactNode;
  bgcolor?: string;
  textcolor?: string;
  padding?: string;
  border?: string;
  boxposition?: "top" | "bottom" | "default" | "LB" | "RB" | "RT" | "LT" | "left" | "right";
  height?: string;
  display?: string;
  justifycontent?: string;
  alignitems?: string;
  gridtemplatecolumns?: string;
  onClick?: () => void;
  justifyitems?: string;
  borderradius?: string;
  cursor?:string;
  hover?: boolean | Record<string, string | number>;
  boxhoverOption?:boolean;
  minwidth?:string;
  minheight?:string;
  flex?:string;
  zindex?: number | string;
  className?: string;
  style?: React.CSSProperties;
  boxShadow?: string;
  flexShrink?: string | number;
  whiteSpace?: string;
  textalign?: string;
  color?: string;
  fontSize?: string | number;
  fontWeight?: string | number;
}

const Container = styled.div<StyledBoxProps>`
  background-color: ${(props) => props.bgcolor || "#fff"};
  color: ${(props) => props.textcolor || "#444"};
  padding: ${(props) => props.padding || "13px"};
  margin: ${(props) => props.margin || "0"};
  border: ${(props) => props.border};
  height: ${(props) => props.height};
  width: ${(props) => props.width || "100%"};
  max-width: ${(props) => props.maxwidth};
  display: ${(props) => props.display || "grid"};
  justify-content: ${(props) => props.justifycontent};
  align-items: ${(props) => props.alignitems};
  align-content: ${(props) => props.aligncontent};
  grid-template-columns: ${(props) => props.gridtemplatecolumns};
  justify-items: ${(props) => props.justifyitems};
  place-content: ${(props) => props.placecontent};
  position: ${(props) => props.position && props.position};
  flex: ${(props) => props.flex && props.flex};
  bottom: ${(props) => props.bottom};
  top: ${(props) => props.top};
  box-shadow: ${(props) => props.boxshadow};
  place-self: ${(props) => props.placeself};
  ${(props) => (props.zindex !== undefined ? `z-index: ${props.zindex};` : '')}
  gap: ${(props) => props.gap};
  font-weight: ${(props) => props.fontweight};
  max-height: ${(props) => props.maxheight};
  overflow-y: ${(props) => props.overflow};
  font-size: ${(props) => props.fontsize};
  min-width: ${(props) => props.minwidth};
  min-height: ${(props) => props.minheight};
  border-radius: ${(props) => props.borderradius};
  cursor:${(props) => props.cursor};
  box-sizing: border-box;
  ${(props) =>
    props.hover &&
    `&:hover {
        background-color: ${designSystem.colors.primaryLight};
        color: ${designSystem.colors.text.primary};
      }
    `}

  ${(props) =>
    props.boxposition === "top" &&
    css`
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      border-bottom: none;
    `};

  ${(props) =>
    props.boxposition === "bottom" &&
    css`
      border-top: none;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    `};
    
  ${(props) =>
    props.boxposition === "LB" &&
    css`
      border-bottom-left-radius: 8px;
    `};
    
  ${(props) =>
    props.boxposition === "RB" &&
    css`
      border-bottom-right-radius: 8px;
    `};
    
  ${(props) =>
    props.boxposition === "RT" &&
    css`
      border-top-right-radius: 8px;
    `};
    
  ${(props) =>
    props.boxposition === "LT" &&
    css`
      border-top-left-radius: 8px;
    `};

  ${(props) =>
    props.boxposition === "left" &&
    css`
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    `};
    
  ${(props) =>
    props.boxposition === "right" &&
    css`
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    `};

  ${(props) =>
    props.boxposition === "default" &&
    css`
      border-radius: 8px;
    `};

    ${(props) =>
    props.boxhoverOption &&
    css`
  position: relative;
  transition: transform 0.3s ease-in-out; 

  &:hover {
    transform: translateY(-10px); 
  }
    `};
`;



const StyledBox = ({
  fontsize,
  overflow,
  margin,
  top,
  maxheight,
  maxwidth,
  fontweight,
  gap,
  aligncontent,
  placeself,
  boxshadow,
  bottom,
  position,
  placecontent,
  width,
  children,
  bgcolor,
  textcolor,
  padding,
  border,
  boxposition,
  height,
  display,
  justifycontent,
  alignitems,
  gridtemplatecolumns,
  onClick,
  justifyitems,
  borderradius,
  cursor,
  hover,
  boxhoverOption,
  minwidth,
  minheight,
  flex,
  className,
  style,
}: StyledBoxProps) => {
  return (
    <Container
      className={className}
      style={style}
      flex={flex}
      cursor={cursor}
      fontsize={fontsize}
      overflow={overflow}
      margin={margin}
      top={top}
      maxheight={maxheight}
      maxwidth={maxwidth}
      fontweight={fontweight}
      gap={gap}
      aligncontent={aligncontent}
      placeself={placeself}
      boxshadow={boxshadow}
      position={position}
      bottom={bottom}
      placecontent={placecontent}
      borderradius={borderradius}
      width={width}
      justifyitems={justifyitems}
      onClick={onClick}
      gridtemplatecolumns={gridtemplatecolumns}
      alignitems={alignitems}
      bgcolor={bgcolor}
      textcolor={textcolor}
      padding={padding}
      border={border}
      boxposition={boxposition}
      height={height}
      display={display}
      justifycontent={justifycontent}
      hover={hover}
      boxhoverOption={boxhoverOption}
      minwidth={minwidth}
      minheight={minheight}
    >
      {children}
    </Container>
  );
};

export default StyledBox;
